import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const SearchIcon = (props?: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C12.89 18 14.6038 17.2497 15.8633 16.0322C15.8877 16.0012 15.9148 15.9719 15.9434 15.9434C15.9719 15.9148 16.0012 15.8877 16.0322 15.8633C17.2497 14.6038 18 12.89 18 11ZM20 11C20 13.125 19.2619 15.0766 18.0303 16.6162L21.707 20.293L21.7754 20.3691C22.0957 20.7619 22.0731 21.3409 21.707 21.707C21.3409 22.0731 20.7619 22.0957 20.3691 21.7754L20.293 21.707L16.6162 18.0303C15.0766 19.2619 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11Z"
        fill="#ADB0B9"
      />
    </svg>
  )
}
